// analysisSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest } from "../../API/apiServices";

export const fetchAnalyses = createAsyncThunk(
  "analysis/fetchAnalyses",
  async (page = 1) => {
    console.log("Fetching analyses for page:", page);
    const res = await apiRequest('get', `/api/analysis/?page=${page}`);
    return res;
  }
);

export const deleteAnalysis = createAsyncThunk(
  "analysis/deleteAnalysis",
  async (analysisId) => {
    console.log("Deleting analysis:", analysisId);
    const res = await apiRequest('delete', `/api/analysis/${analysisId}`);
    return { analysisId, response: res };
  }
);

const analysisSlice = createSlice({
  name: "analysis",
  initialState: { 
    models: [], 
    total_models: 0,
    status: "idle" 
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalyses.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAnalyses.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.models = action.payload.models;
        state.total_models = action.payload.total_models;
      })
      .addCase(fetchAnalyses.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(deleteAnalysis.fulfilled, (state, action) => {
        // Remove the deleted analysis from all models
        state.models = state.models.map(model => ({
          ...model,
          data: model.data.filter(analysis => analysis.id !== action.payload.analysisId),
          pagination: {
            ...model.pagination,
            total_count: model.data.filter(analysis => analysis.id !== action.payload.analysisId).length
          }
        }));
      })
      .addCase(deleteAnalysis.rejected, (state) => {
        // Optionally handle rejection, but no status change
      });
  },
});

export const { } = analysisSlice.actions;
export default analysisSlice.reducer;
